import {Component, Inject, OnInit, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {JobTask} from '../../../shared/classes/job-task/job-task';
import {JobTaskService} from '../../../shared/services/job-task/job-task.service';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {JobTaskStatus} from '../../../shared/enum/job-task-status.enum';
import {EventMessageService} from '../../../shared/services/server-sent-event/event-message.service';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-job-task-modal-view',
  templateUrl: './export-csv-task-modal.component.html',
  styleUrls: ['./export-csv-task-modal.component.css']
})
export class ExportCsvTaskModalComponent implements OnInit, OnDestroy {

  private injectedData: any;
  public isLoading: boolean;
  public jobTask: JobTask;
  public faTimes = faTimes;
  public showSpinner = false;
  public jobTaskStatus = JobTaskStatus;
  public remainingProgress = '';
  public serverSentEventSubscription: Subscription;
  public progressValue: number;
  private intervalId!: any;

  constructor(private jobTaskService: JobTaskService,
              private eventMessageService: EventMessageService,
              private translateService: TranslateService,
              private toastr: ToastrService,
              @Inject(MAT_DIALOG_DATA) data: any) {
    this.injectedData = data;
  }

  ngOnInit() {

    this.getJobTask();
    this.intervalId = setInterval(() => {
      this.getJobTask();
    }, 10000);
  }

  ngOnDestroy() {
    if (this.serverSentEventSubscription instanceof Subscription) {
      this.serverSentEventSubscription.unsubscribe();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private getJobTask() {
    this.isLoading = true;
    this.jobTaskService.getJobTask(this.injectedData.jobTaskId)
      .subscribe((jobTask: any) => {
        this.jobTask = jobTask;
        // if (jobTask.detail.current_location && jobTask.detail.current_location.total && jobTask.detail.current_location.iteration) {
        //   this.remainingProgress = jobTask.detail.current_location.total - jobTask.detail.current_location.iteration + '/' +
        //     jobTask.detail.current_location.total;
        // } else {
        //   this.remainingProgress = '';
        // }

        this.isLoading = false;
      });
  }
}
